import React from "react";
import { useParams } from "react-router-dom";

import Bike from "../New_Templates/Bike";
import Mining from "../New_Templates/Mining";
import SchoolBus from "../New_Templates/school_bus";

const createSlug = (text) => {
  return text
    ?.toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, "")
    .replace(/\s+/g, "-");
};

function ThemeDetails({ websiteData }) {
  const { slug } = useParams();

  // Extract ID from slug
  // const id = slug?.split("-").pop();

  // // Find product
  // const product = websiteData?.find(
  //   (item) => String(item.id) === String(id)
  // );

  // Create slug


  // Find product using slug
  const product = websiteData?.find(
    (item) => createSlug(item.name) === slug
  );

  // Product not found
  if (!product) {
    return <h1>Product Not Found</h1>;
  }

  // Theme-based rendering
  if (product.layoutType === "theme1") {
    return <Bike websiteData={websiteData} />;
  }

  if (product.layoutType === "theme2") {
    return <Mining websiteData={websiteData} />;
  }

  if (product.layoutType === "theme3") {
    return <SchoolBus websiteData={websiteData} />;
  }

  return <h1>Invalid Theme</h1>;
}

export default ThemeDetails;